import {
  GroupOrderBagCancelModal,
  GroupOrderBagLeaveModal,
  GroupOrderBagShareModal,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagModal = {
  Share: GroupOrderBagShareModal,
  Cancel: GroupOrderBagCancelModal,
  Leave: GroupOrderBagLeaveModal,
};
